import PropTypes from 'prop-types'
import React, { Component } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import WorkoutForm from '../WorkoutForm'
import PageHeader from 'components/util/PageHeader'
import { FormattedMessage } from 'react-intl'
import { Modal, Loader, Svg } from 'components/util'
import { ImportWorkouts, GoMobile } from 'components/sidebar'
import styles from './_logWorkoutPage.css'
import * as workoutActions from 'services/workouts/actions'
import { selectWorkoutSaving } from 'services/workouts/selectors'
import { selectLocation } from 'services/routing/selectors'
import { AD_SIZES } from 'services/ads/constants'
import Ad from 'components/util/ads/Ad'

const mapStateToProps = state => ({
  saving: selectWorkoutSaving(state),
  location: selectLocation(state),
})

const mapDispatchToActions = {
  ...workoutActions,
}

export class LogWorkoutPage extends Component {

  static propTypes = {
    createWorkout: PropTypes.func,
    saving: PropTypes.bool,
    loading: PropTypes.bool,
    location: PropTypes.object,
  }

  state = {
    saving: false,
  }

  handleSubmit = (values) => {
    this.setState({ saving: true })
    this.props.createWorkout(values)
      .then(({ value: { data }}) => {
        const newWorkoutId = data._links.self[0].id
        window.location.href = `/workout/${newWorkoutId}/`
      })
      .catch(() => this.setState({ saving: false }))
  }

  render () {
    const { saving } = this.state
    const { location: { query: { date }}} = this.props

    let defaultDate

    if (date) {
      defaultDate = moment(date, 'YYYY-MM-DD')
      if (!defaultDate.isValid()) {
        defaultDate = null
      }
    }

    return (
      <Row>
        <Col xs={12} sm={8}>

          <PageHeader>
            <h1 className={styles.title}>
              <FormattedMessage
                id='workouts.create.log_a_workout'
                defaultMessage='Log a workout'
              />
            </h1>
          </PageHeader>

          <div className={styles.description}>
            <Svg name='dumbbell_circle' className={styles.dumbbell} />
            <p>
              <FormattedMessage
                id='workouts.create.description'
                defaultMessage={`
                  If you\'ve been active, get credit for it!
                  Add your workout details below, and stay on top of your fitness goals.
                `}
              />
            </p>
          </div>

          <WorkoutForm
            mode='create'
            className={styles.workoutForm}
            onSubmit={this.handleSubmit}
            defaultDate={defaultDate}
          />

          <Modal isOpen={saving} preventBodyScroll={false}>
            <div className={styles.loadingModal}>
              <div>
                <Loader height={50} width={50} />
              </div>
              <h3 className={styles.loadingTitle}>
                <FormattedMessage
                  id='workout.create.saving_workout'
                  defaultMessage='Saving workout...'
                />
              </h3>
            </div>
          </Modal>

        </Col>

        <Col xs={12} sm={4}>
          <ImportWorkouts />
          <Ad sizes={[AD_SIZES.RAIL_2]} />
          <GoMobile />
          <Ad sizes={[AD_SIZES.RAIL_2]} position={'bottom'} />
        </Col>

      </Row>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(LogWorkoutPage)
